import React from 'react'
import PropTypes from 'prop-types'

export const FormAction = ({ children }) => (
  <div className='ui-form__action'>{children}</div>
)
FormAction.propTypes = {
  children: PropTypes.any
}
